import React from "react";
import { Radio } from "antd";
import style from "./style.scss";

const ReversedRadio = props => (
  <Radio className={style.radio} {...props}>
    {props.label}
  </Radio>
);

export default ReversedRadio;



// WEBPACK FOOTER //
// ./src/components/FormControls/ReversedRadio/index.tsx